import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'FinancialDiscountCapital',
  data: function data() {
    var _this = this;

    return {
      datePickerValue: [(dateUtils.todayTimestamp() - 86400) * 1000, (dateUtils.todayTimestamp() - 86400) * 1000],
      sheetType: 1,
      slotCounterName: 'StationDiscountCapitalCounter',
      switchValue: false,
      loading: false,
      sheetUnLoadCount: 1,
      downloadLoading: false,
      excelSheets: [{
        tableId: 'tableStationDiscountCapital',
        name: '优惠出资汇总',
        tableRows: 2
      }],
      slotOption: '',
      selectedOilCode: '92',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      groupData: [],
      renderData: [],
      borderFix: ['合计/L', '合/L', '0#'],
      cellColClassFix: ['monthSumUserNums', 'monthGoodsPrice', 'monthAvgUserPrice', 'monthDiffUserPrice', 'monthSumSvcNums', 'monthAvgSvcPrice', 'monthDiffSvcPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  watch: {
    datePickerValue: function datePickerValue() {// this.loadDiscountCapitalData()
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  created: function created() {// this.loadDiscountCapitalData()
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['tableStationDiscountCapital' + _this2.sheetType].doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['tableStationDiscountCapital' + this.sheetType].doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    percentShow: function percentShow(a, b) {
      if (b === 0) return '0%';
      return NP.round(NP.times(NP.divide(Number(a), Number(b)), 100), 2) + '%';
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    percentFormat: function percentFormat(value1, value2) {
      return value2 === 0 ? '--' : NP.round(NP.divide(value1, value2) * 100, 2) + '%';
    },
    numsFormat: function numsFormat(value) {
      return NP.round(NP.divide(value, 10000), 2);
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];

      var _that = this;

      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (column.property === 'totalA') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data0'], item['data1'], item['data2'], item['data3'], item['data4'], item['data5'], item['data6'], item['data7']));
          });
        } else if (column.property === 'totalB') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data8'], item['data9'], item['data10'], item['data11'], item['data12'], item['data13'], item['data14'], item['data15']));
          });
        } else if (column.property === 'totalC') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data16'], item['data17'], item['data18'], item['data19'], item['data20'], item['data21'], item['data22'], item['data23']));
          });
        } else if (column.property === 'total') {
          values = data.map(function (item) {
            return Number(_that.npPlus(item['data0'], item['data1'], item['data2'], item['data3'], item['data4'], item['data5'], item['data6'], item['data7'], item['data8'], item['data9'], item['data10'], item['data11'], item['data12'], item['data13'], item['data14'], item['data15'], item['data16'], item['data17'], item['data18'], item['data19'], item['data20'], item['data21'], item['data22'], item['data23']));
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadDiscountCapitalData: function loadDiscountCapitalData() {
      var _this3 = this;

      if (this.downloadLoading) {
        return;
      }

      this.downloadLoading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: parseInt(this.sheetType),
          name: this.slotCounterName,
          start: this.datePickerValue[0] / 1000,
          end: this.datePickerValue[1] / 1000,
          search: ''
        }]
      };
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this3.renderData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.stationId) - orders.indexOf(b.stationId);
        });
        _this3.downloadLoading = false;
        _this3.sheetUnLoadCount = 0;

        _this3.$refs['tableStationDiscountCapital' + _this3.sheetType].doLayout();
      }).catch(function () {
        _this3.downloadLoading = false;
      });
    },
    monthStart: function monthStart(ts) {
      return moment(new Date(ts)).startOf('month').unix() * 1000;
    },
    monthEnd: function monthEnd(ts) {
      return moment(new Date(ts)).endOf('month').unix() * 1000;
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this4 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 5 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this4.datePickerValue[0]).format('YYYY年MM月DD日') + '~' + moment(_this4.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this4.downloadLoading = false;
      }).catch(function () {
        _this4.downloadLoading = false;
      });
    }
  }
};